module.exports = __webpack_public_path__ + "static/img/customerService.8bf7fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/customerService.png
// module id = aeL0
// module chunks = 96